<template>
  <div :class="`chart school-engagement md-layout-item md-size-${width} md-medium-size-${width} md-small-size-100`">
    <div class="school-engagement">
      <h2>{{label}}</h2>
      <div class="">
        <apexchart type=bar height=360 :options="chartOptions" :series="series" />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "SchoolEngagement",
  computed: {},
  components: {
    apexchart: VueApexCharts
  },
  mounted() {},

  data() {
    let topSubgroups = window.drupalSettings.controller.graphs.SubGroupEngagement.data;
    let series = []
    series.push({
      name: 'Strategies viewed',
      data: topSubgroups.map((subgroup) => {
        return subgroup.views
      })
    })
    series.push({
      name: 'Strategies badged',
      data: topSubgroups.map((subgroup) => {
        return subgroup.completed
      })
    })

    let categories = topSubgroups.map((subgroup) => {
      return subgroup.title
    })
    return {
      label: window.drupalSettings.controller.graphs.SubGroupEngagement.label,
      width: window.drupalSettings.controller.graphs.SubGroupEngagement.width || 33,
      series: series,
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          },
          offsetX: -15,
          offsetY: -5,
        },
        colors: ['#457b9d', '#b0d7b9'],
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: 'top',
            },
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        legend: {
          fontSize: "14px",
          fontFamily: 'Source Sans Pro',
          offsetY: -5,
          floating: true,
          labels: {
            colors: ['#3c3c3c'],
          },
        },
        xaxis: {
          categories: categories,
          labels: {
            style: {
              colors: ['#3c3c3c'],
              fontSize: '14px',
              fontFamily: 'Source Sans Pro',
            },
            formatter: function(value) {
              return (value.length > 15) ? value.slice(0, 15) + '...' : value
            },
            trim: true,
            minHeight: 70,
          },
          axisBorder: {
            show: true,
            color: '#cccccc',
          },
          axisTicks: {
              show: true,
              color: '#fff'
          },
        },
        yaxis: {
          title: {
            offsetX: -10,
            offsetY: 0,
          },
          labels: {
            style: {
              color: '#3c3c3c',
              fontSize: "16px",
              fontFamily: 'Source Sans Pro'
            },
          },
        },
        // fill: {
        //   type: 'gradient',
        //   gradient: {
        //     shade: 'dark',
        //     type: "vertical",
        //     shadeIntensity: 0.5,
        //     gradientToColors: ['#3D9AB9', '#FEA104'], // optional, if not defined - uses the shades of same color in series
        //     inverseColors: true,
        //     opacityFrom: 1,
        //     opacityTo: 1,
        //   }
        // },
        tooltip: {
          x: {
            formatter: function(val) {
              return val
            },
          },
          y: {
            formatter: function (val) {
              return val
            }
          }
        }
      }
    };
  },

  methods: {}
};
</script>
<style lang="scss">
  .school-engagement {
    .apexcharts-legend {
      //transform: translate(20px, 0px);
    }
    .apexcharts-canvas {
      //transform: translate(-20px, -10px);
    }
  }
</style>
